export default __webpack_public_path__ + "static/media/IMG-20241005-WA0031.cb6f16af.jpg";